import { computed, unref } from 'vue';
import { getSymbolFromCurrencyCode } from '../utils/component-lib.esm13.js';
function useCurrency(currencyCode) {
  return computed(() => {
    const code = unref(currencyCode);
    return {
      symbol: getSymbolFromCurrencyCode(code)
    };
  });
}
export { useCurrency };